import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const DocsRar = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '24',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 18 22'
    >
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M7 11v-1m0 7v-2m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 6V5m4-4v4a2 2 0 0 0 2 2h4m-4.5 14H15a2 2 0 0 0 2-2V6l-5-5H3a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01'
      />
    </svg>
  );
};
